module.exports = __webpack_public_path__ + "static/media/press_content_09.aceb9127.png";